import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { trackAddToCart } from '../utils/metaPixel';
export const PricingOffer = () => {
  return <section id="pricing" className="py-20 px-6 bg-brand-navy text-white relative overflow-hidden" data-id="element-107">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-108">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-brand-lavender/20 rounded-full blur-3xl" data-id="element-109"></div>
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black/20 to-transparent" data-id="element-110"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-111">
        {/* Proof / Believability */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-112">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-113">
            Lo que cambia en 7 días:
          </h2>
          <p className="text-xl md:text-2xl text-white/90 leading-relaxed font-playfair italic max-w-3xl mx-auto" data-id="element-114">
            "Pasarás de una madre agotada que llora de frustración a las 2 AM, a
            una mujer con claridad mental que puede disfrutar de su bebé por la
            mañana, sabiendo que ambos han descansado en bloques de 6 a 8 horas
            de sueño reparador."
          </p>
        </motion.div>

        {/* The Offer Box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white text-brand-charcoal rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto text-center relative" data-id="element-115">
          <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-brand-coral text-white font-bold px-6 py-2 rounded-full text-sm shadow-lg whitespace-nowrap" data-id="element-116">
            DESCUENTO POR TIEMPO LIMITADO
          </div>

          <h3 className="text-2xl font-bold text-brand-navy mb-4 mt-4" data-id="element-117">
            Recupera tu vida hoy mismo.
          </h3>
          <p className="text-lg text-brand-charcoal/80 mb-8" data-id="element-118">
            No tienes que esperar a que tu hijo "crezca" para volver a dormir.
            El agotamiento no tiene por qué ser tu normalidad.
          </p>

          <div className="mb-6" data-id="element-119">
            <img src="https://cdn.magicpatterns.com/uploads/q3HLZwTLMHCKnnHaks8gaD/LP2.png" alt="El Método Sueño Profundo - Paquete completo con ebook, guías y audios" className="w-full max-w-md mx-auto rounded-2xl" data-id="element-120" />
          </div>

          <div className="mb-8 p-6 bg-brand-cream rounded-2xl border border-brand-lavender/20" data-id="element-121">
            <p className="text-sm text-brand-charcoal/60 uppercase tracking-wide font-bold mb-2" data-id="element-122">
              Obtén el Método Completo por solo
            </p>
            <div className="text-5xl md:text-6xl font-bold text-brand-navy" data-id="element-123">
              <PriceDisplay data-id="element-124" />
            </div>
          </div>

          <a href="https://www.rutinaspracticas.com/cart/52836173414722:1" onClick={trackAddToCart} className="btn-gold-3d block w-full text-white font-bold text-xl py-5 px-8 rounded-xl transition-all transform hover:-translate-y-1 active:translate-y-0 mb-6 tracking-wide uppercase" data-id="element-125">
            ¡SÍ, QUIERO DORMIR OTRA VEZ!
          </a>

          <p className="text-sm text-brand-charcoal/60 mb-8" data-id="element-126">
            Descargar Ahora (Acceso instantáneo en formato PDF, incluso si son
            las 3 AM)
          </p>

          {/* Trust Elements */}
          <div className="flex flex-col items-center gap-4 pt-6 border-t border-gray-100" data-id="element-127">
            <div className="flex items-center justify-center gap-6 text-brand-charcoal/50" data-id="element-128">
              <div className="flex items-center gap-1 text-sm font-medium" data-id="element-129">
                <Lock className="w-4 h-4" data-id="element-130" /> Pago Seguro
              </div>
              <div className="flex items-center gap-1 text-sm font-medium" data-id="element-131">
                <ShieldCheck className="w-4 h-4" data-id="element-132" /> Garantía
              </div>
              <div className="flex items-center gap-1 text-sm font-medium" data-id="element-133">
                <CreditCard className="w-4 h-4" data-id="element-134" /> Tarjetas / PayPal
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};